import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Paper, TextField, Button, Typography, Alert, Stack, Box } from '@mui/material';
import { api } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export default function ChangePasswordPage() {
  const { refresh, user } = useAuth();
  const nav = useNavigate();
  const [cur, setCur] = useState('');
  const [pwd, setPwd] = useState('');
  const [err, setErr] = useState(''); const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(''); setBusy(true);
    try {
      await api.post('/api/auth/change-password', { currentPassword: cur, newPassword: pwd });
      await refresh(); nav('/');
    } catch (e) { setErr(e?.response?.data?.message || 'Could not change password'); }
    finally { setBusy(false); }
  };
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', bgcolor: 'background.default' }}>
      <Container maxWidth="xs">
        <Paper sx={{ p: 4 }}>
          <Typography variant="h6" gutterBottom>Change your password</Typography>
          {user?.mustChangePassword && <Alert severity="info" sx={{ mb: 2 }}>You must change your password before continuing.</Alert>}
          <form onSubmit={submit}>
            <Stack spacing={2}>
              {err && <Alert severity="error">{err}</Alert>}
              <TextField label="Current password" type="password" value={cur} onChange={e => setCur(e.target.value)} required />
              <TextField label="New password" type="password" value={pwd} onChange={e => setPwd(e.target.value)} required inputProps={{ minLength: 8 }} />
              <Button type="submit" variant="contained" disabled={busy}>Update password</Button>
            </Stack>
          </form>
        </Paper>
      </Container>
    </Box>
  );
}
